import { MaskitoOptions } from "@maskito/core";
import {
  maskitoCaretGuard,
  maskitoEventHandler,
  maskitoNumberOptionsGenerator,
} from "@maskito/kit";
import { replaceDefaultOnInputPlugin } from "./plugins";

const POSTFIX = " kr." as const;

export function createPriceInputMask(opts?: {
  initialValue?: number;
  onChange?: (n: number) => void;
}): MaskitoOptions {
  return {
    ...maskitoNumberOptionsGenerator({
      min: 0,
      thousandSeparator: ".",
      decimalSeparator: ",",
      postfix: POSTFIX,
    }),
    plugins: [
      maskitoCaretGuard((value) => [0, value.length - POSTFIX.length]),
      replaceDefaultOnInputPlugin({ suffix: POSTFIX, default: "0" }),
      maskitoEventHandler("blur", (el) => {
        if (el.value === POSTFIX) {
          el.value = `0${POSTFIX}`;
        }
      }),
      maskitoEventHandler("input", (el) => {
        opts?.onChange?.(extractNumberFromPriceInput(el.value));
      }),
      (el) => {
        if (el.getAttribute("initialized") === "true") return;
        el.value = `${opts?.initialValue ? opts?.initialValue : "0"}${POSTFIX}`;
        el.setAttribute("initialized", "true");
      },
    ],
  };
}

export const priceRegex = /^([\d.,]+) kr\.$/;
export function extractNumberFromPriceInput(raw: string): number {
  const result = raw.match(priceRegex);
  if (result) {
    // NOTE: Broken into steps for easy debugging.
    // Avoid the temptation to chain this.
    let priceString = result[1];
    priceString = priceString.replace(/\./, "");
    priceString = priceString.replace(/,/, ".");
    return Number(priceString);
  }
  return 0;
}
